<div class="container fw-b">
    <app-linker-route [headingName]="headingName" [linkerRouteItems]="linkerRouteItems"></app-linker-route>
</div>

<div class="container mt-4">
    <div class="row justify-content-center">
        <div class="col-xl-6 col-lg-8 col-md-10">
            <div class="change-password-card">
                <div class="card-header">
                    <h2 class="page-title">Change Password</h2>
                    <p class="page-subtitle">Update your password to keep your account secure</p>
                </div>
                
                <div class="card-body">
                    <form [formGroup]="changPassword">
                        <!-- Old Password -->
                        <div class="form-group-modern">
                            <label class="form-label-modern" for="oldPassword">
                                Old Password <span class="required">*</span>
                            </label>
                            <div class="input-wrapper">
                                <input 
                                    [type]="changetype ? 'password' : 'text'" 
                                    class="form-control-modern" 
                                    id="oldPassword" 
                                    placeholder="Enter old password"
                                    formControlName="oldpassword" 
                                    maxlength="16"
                                    (keypress)="preventSpace($event)" 
                                    onselectstart="return false;" 
                                    onpaste="return false;" 
                                    oncopy="return false;"
                                    oncut="return false" 
                                    ondrag="return false" 
                                    ondrop="return false" 
                                    autocomplete="off"
                                />
                                <span class="password-toggle" (click)="viewpass()">
                                    <i [ngClass]="visible ? 'fa fa-eye' : 'fa fa-eye-slash'"></i>
                                </span>
                            </div>
                            <div class="validation-error" 
                                *ngIf="changPassword.get('oldpassword')?.hasError('required') && changPassword.get('oldpassword')?.touched">
                                Old password is required.
                            </div>
                        </div>
                        
                        <!-- New Password -->
                        <div class="form-group-modern">
                            <label class="form-label-modern" for="newPassword">
                                New Password <span class="required">*</span>
                            </label>
                            <div class="input-wrapper">
                                <input 
                                    [type]="changetypes ? 'password' : 'text'" 
                                    class="form-control-modern" 
                                    id="newPassword" 
                                    placeholder="Enter new password"
                                    formControlName="password" 
                                    maxlength="16" 
                                    (keypress)="preventSpace($event)" 
                                    onselectstart="return false;" 
                                    onpaste="return false;" 
                                    oncopy="return false;"
                                    oncut="return false" 
                                    ondrag="return false" 
                                    ondrop="return false" 
                                    autocomplete="off"
                                />
                                <span class="password-toggle" (click)="viewpas()">
                                    <i [ngClass]="visibles ? 'fa fa-eye' : 'fa fa-eye-slash'"></i>
                                </span>
                            </div>
                            <div class="validation-error"
                                *ngIf="changPassword.get('password')?.hasError('required') && changPassword.get('password')?.touched">
                                New password is required.
                            </div>
                        </div>
                        
                        <!-- Confirm Password -->
                        <div class="form-group-modern">
                            <label class="form-label-modern" for="confirmPassword">
                                Confirm Password <span class="required">*</span>
                            </label>
                            <div class="input-wrapper">
                                <input 
                                    [type]="cengesestype ? 'password' : 'text'" 
                                    class="form-control-modern" 
                                    id="confirmPassword" 
                                    placeholder="Confirm new password"
                                    formControlName="confirmPassword" 
                                    maxlength="16" 
                                    onselectstart="return false;" 
                                    onpaste="return false;" 
                                    oncopy="return false;"
                                    oncut="return false" 
                                    ondrag="return false" 
                                    ondrop="return false" 
                                    autocomplete="off"
                                />
                                <span class="password-toggle" (click)="viewpassd()">
                                    <i [ngClass]="visibled ? 'fa fa-eye' : 'fa fa-eye-slash'"></i>
                                </span>
                            </div>
                            <div class="validation-error"
                                *ngIf="changPassword.get('confirmPassword')?.hasError('required') && changPassword.get('confirmPassword')?.touched; else elseBlock">
                                Confirm password is required.
                            </div>
                            <ng-template #elseBlock>
                                <div class="validation-error" 
                                    *ngIf="(changPassword.get('password')?.value != changPassword.get('confirmPassword')?.value) && changPassword.get('confirmPassword')?.dirty">
                                    Password and confirm password must match.
                                </div>
                            </ng-template>
                        </div>
                        
                        <!-- Action Buttons -->
                        <div class="action-buttons">
                            <button class="btn-secondary-action" (click)="navigateToProfile()" type="button">
                                <i class="fa fa-arrow-left mr-2"></i>Back
                            </button>
                            <button class="btn-primary-action" (click)="navigateTochangePassword()" type="submit"
                                [disabled]="!changPassword.valid">
                                <i class="fa fa-check mr-2"></i>Update Password
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>
